import { AppsContainer } from "@lib/components/AppComponents";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { useTypedSelector } from "@lib/redux";
import { useManagerQueries } from "@lib/apiQueries";
import { getRoute } from "@lib/helpers/RouteHelper";
import { ROUTES } from "@lib/constants";
import { useMemo } from "react";
import { getMyProfileTabs } from "./Tabs";

const MyProfile = () => {
  const { messages } = useIntl();
  const Tabs = getMyProfileTabs();
  const { tab = Tabs[0].key } = useParams();
  const navigate = useNavigate();
  const { user } = useTypedSelector((state) => state.auth);

  const onChange = (newActiveKey: string) => {
    navigate(getRoute(ROUTES.MY_PROFILE.DETAIL_TAB, { tab: newActiveKey }), {
      replace: true,
    });
  };

  const ActiveTab = useMemo(() => {
    return Tabs.find((item) => item.key === tab);
  }, [tab]);

  const { managerQuery, updateManagerMutation } = useManagerQueries({
    id: user?.id,
    messages,
    enabled: !!user?.id,
  });
  const loading =
    managerQuery.isLoading || managerQuery.isFetching || !ActiveTab;

  return (
    <AppsContainer
      fullView
      isLoading={loading}
      cardStyle={{ background: "transparent", boxShadow: "none" }}
      title={messages["common.myProfile"] as string}
      cardProps={{
        borderFull: true,
        coloredHeader: true,
      }}
      sidebarContent={
        <AppsContainer.SidebarMenu
          data={Tabs.map((item) => ({
            ...item,
            isActive: item.key === tab,
            onClick: () => onChange(item.key),
            props: {
              query: managerQuery,
              updateQuery: updateManagerMutation,
            },
          }))}
          loading={loading}
          onClick={onChange}
          activeKey={tab}
        />
      }
      breadcrumbProps={{
        urlParams: {
          tab: Tabs.find((item) => item.key === tab)?.Title as string,
        },
      }}
    >
      <ActiveTab.Component
        query={managerQuery}
        updateQuery={updateManagerMutation}
        loading={loading}
      />
    </AppsContainer>
  );
};

export default MyProfile;
